import { ReactNode } from 'react'

type IconData = {
  subData?: string
  data?: string
}

interface IProps {
  icon: ReactNode
  title: string
  data: IconData[]
}

const JobIconData = ({ icon, title, data }: IProps) => (
  <div className='flex mt-6'>
    <div className=' w-10 mr-5 mt-1 xl:mt-2 flex justify-center'>{icon}</div>
    <div>
      <p className='text-gray-400 text-xs xl:text-sm mb-0.5'>{title}</p>
      {data.map((item, index) => (
        <div key={index}>
          {item.data && (
            <p className='text-md xl:text-c22 leading-6'>
              {item.data}{' '}
              {item.subData && (
                <span className='text-gray-400 text-sm xl:text-sm mb-2'>
                  {item.subData}
                </span>
              )}
            </p>
          )}
        </div>
      ))}
    </div>
  </div>
)

export default JobIconData
